import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ngxPermissionsGuard } from 'ngx-permissions';



const routes: Routes = [
  {
    path: '',
    data: { permissions: { only: ['Admin', 'Administrator', 'Manager'], redirectTo: '/dashboard' } },
    canActivate: [ngxPermissionsGuard],
    loadComponent: () => import('./components/users-list/users-list.component').then(m => m.UsersListComponent),
  },
  // beaut-491's duplicate list is routed from the ADMIN section
  // (`/admin/customer-duplicates`), not from here. The component stays in this
  // lib because it opens `UserViewComponent`, which lives here; moving it would
  // buy a cross-lib import and nothing else.
  {
    path: 'upload',
    data: { permissions: { only: ['Admin', 'Manager'], redirectTo: '/dashboard' } },
    canActivate: [ngxPermissionsGuard],
    loadComponent: () => import('./containers/users-upload/users-upload.component').then(m => m.UsersUploadComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UsersRoutingModule {}
